import React, { useState, useEffect } from 'react';
import AddAreaModal from '../AddAreaModal/AddAreaModal';
import AreaService from '../../services/areaService';
import { useOktaAuth } from '@okta/okta-react';
import DropdownSearch from '../DropdownSearch/DropdownSearch';
import { Area } from '../../types/apiData';

interface DropdownSearchWithInsertProps {
    createAreaHeaderLabel: string;
    parentAreaId: string | null;
    isRootArea: boolean;
    dropdownId: string;
    dropdownLabel: string;
    dropdownPlaceholder: string;
    dropdownValue: string;
    dropdownRequired: boolean;
    dropdownToolTip?: string;
    dropdownGetOptions: () => Promise<Area[]>;
    dropdownOnSearchChange: (value: string) => void;
    dropdownOnOptionSelect: (id: string, name: string) => void;
    dropdownDisabled?: boolean;
}

const DropdownSearchWithInsert: React.FC<DropdownSearchWithInsertProps> = ({
    createAreaHeaderLabel,
    parentAreaId,
    isRootArea,
    dropdownId,
    dropdownLabel,
    dropdownPlaceholder,
    dropdownValue,
    dropdownRequired,
    dropdownToolTip,
    dropdownGetOptions,
    dropdownOnSearchChange,
    dropdownOnOptionSelect,
    dropdownDisabled = false,
}) => {
    const [newAreaName, setNewAreaName] = useState('');
    const { authState } = useOktaAuth();
    const [dropdownOptions, setDropdownOptions] = useState<Area[]>([]);

    useEffect(() => {
        const fetchDropdownOptions = async () => {
            const options = await dropdownGetOptions();
            setDropdownOptions(options);
        };
        fetchDropdownOptions();
    }, [dropdownGetOptions]);


    const areaService = new AreaService();

    const handleModalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewAreaName(event.target.value);
    };

    const handleModalSubmit = async () => {
        if (!newAreaName.trim()) {
            console.error('New area is empty');
            return;
        }

        if (!isRootArea && !parentAreaId) {
            console.error('Parent area ID is required for non-root areas');
            return;
        }

        areaService.createArea(newAreaName, parentAreaId, authState)
            .then(async (response) => {
                console.log('Area created successfully:', response);
                alert('Area created successfully');
                setNewAreaName(''); // Clear the input field after submission

                // Update the dropdown options with the new area
                setDropdownOptions(await dropdownGetOptions());
            })
            .catch((error) => {
                console.error('Error creating area:', error);
            });
    };

    const handleModalClose = () => {
        setNewAreaName(''); // Clear the input field when the modal closed
    }

    return (
        <div className=''>
            <div className="row d-flex align-items-center">
                <div className="col-5 col-sm-5 col-md-6 col-lg-7 col-xl-8 pe-0 me-0">
                    <DropdownSearch
                        id={dropdownId}
                        label={dropdownLabel}
                        placeholder={dropdownPlaceholder}
                        value={dropdownValue}
                        options={dropdownOptions}
                        onSearchChange={(value) => {
                            dropdownOnSearchChange(value);
                        }}
                        onOptionSelect={dropdownOnOptionSelect}
                        required={dropdownRequired}
                        tooltip={dropdownToolTip}
                        disabled={dropdownDisabled}
                    />
                </div>
                <div className="col-7 col-sm-7 col-md-5 col-lg-5 col-xl-4 ps-0 pt-3">
                    <AddAreaModal
                        modalHeaderLabel={createAreaHeaderLabel}
                        value={newAreaName}
                        addButtonEnabled={isRootArea || !!parentAreaId}
                        handleChange={handleModalChange}
                        handleSubmit={handleModalSubmit}
                        handleClose={handleModalClose}
                    />
                </div>
            </div>
        </div>
    );
};

export default DropdownSearchWithInsert;